import { Box, Grid } from "@mui/material";
import React, { useEffect } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";

import { callAPI, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";

import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const StockLedgerList: React.FC = () => {

  const { showMessage } = useSnackbar();

  const [warehouse, setWarehouseOptions] = React.useState<any[]>([]);
  const [items, setItemOptions] = React.useState<any[]>([]);

  // Header
  useEffect(() => {
    updateMainHeader("Inventory");
    labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
  }, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Stock Verification": "/verification/list" },
  ]);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await callAPI('items/list', Method.GET);
        console.log("Items API Response:", res); // Debug log

        setItemOptions(
          res.data.results.map((b: any) => ({ label: b.ItemName, value: b.ItemName })) || []
        );
        setWarehouseOptions(
          res.data.results.map((b: any) => ({ label: b.WarehouseName, value: b.WarehouseName })) || []
        );
      } catch (error) {
        console.error("Failed to fetch items:", error);
        showMessage("Failed to load items", "error");
      }
    };

    fetchItems();
  }, [])

  const source = {
    url: "stock-ledger/list",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const
  };

  const columns: IColumns[] = [
    { header: "Date", fieldName: "CreatedDate", type: "date" },
    { header: "Item Name", fieldName: "ItemName" },
    { header: "Reference", fieldName: "ReferenceType" },
    { header: "Quantity", fieldName: "Quantity" },
    { header: "Warehouse Name", fieldName: "WarehouseName" },
    { header: "User", fieldName: "CreatedByName" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Delete"],
      actionCallback: (action: string, row: any) => {
        const LedgerId = row.LedgerId;
        if (!LedgerId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }
      },
    },
  ];

  const filterFields = [
    { type: "text", fieldName: "transaction_type", label: "Transaction Type", operator: "eq" },
    
    { type: "date", fieldName: "start_date", label: "Start Date" },
    { type: "date", fieldName: "end_date", label: "End Date" },

    { type: "dropdown", fieldName: "warehouse_name", label: "Warehouse", options: warehouse },
    { type: "dropdown", fieldName: "item_name", label: "Item", options: items },
  ];

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>

          { }
          {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <h2>Stock Ledger</h2>
          </Box> */}

          { }
          <WSDataGrid
            id="itemMasterGrid"
            title="Stock Ledger"
            headerType="modern"
            columns={columns}
            source={source}
            exportCsv
            rowsPerPageCount={10}
            filterFields={filterFields}
            searchBox={{ searchMode: "query" }}
          />

        </Grid>
      </Grid>
    </Grid>
  );
};
